import { FaFacebookF, FaInstagram, FaTiktok, FaXTwitter, FaYoutube } from "react-icons/fa6";
import { SOCIALS } from "@/data/content";

const items = [
  { key: "facebook", href: SOCIALS.facebook, Icon: FaFacebookF, label: "Facebook" },
  { key: "instagram", href: SOCIALS.instagram, Icon: FaInstagram, label: "Instagram" },
  { key: "tiktok", href: SOCIALS.tiktok, Icon: FaTiktok, label: "TikTok" },
  { key: "x", href: SOCIALS.x, Icon: FaXTwitter, label: "X" },
  { key: "youtube", href: SOCIALS.youtube, Icon: FaYoutube, label: "YouTube" },
];

export const SocialIcons = ({ size = "md", className = "" }) => {
  const dim = size === "lg" ? "h-12 w-12" : "h-10 w-10";
  const ic = size === "lg" ? "h-5 w-5" : "h-[18px] w-[18px]";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="social-icons">
      {items.map(({ key, href, Icon, label }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`social-${key}`}
          className={`${dim} flex items-center justify-center rounded-full border border-white/15 bg-white/5 text-white/85 transition-colors hover:border-[#B12A2A] hover:bg-[#B12A2A] hover:text-white`}
        >
          <Icon className={ic} />
        </a>
      ))}
    </div>
  );
};
